import { jsxs, jsx } from 'react/jsx-runtime';
import cx from 'clsx';
import { useRef, useState, useMemo, useEffect } from 'react';
import { debounce } from '../utils/debounce/index.js';
import { s as styleInject } from './style-inject.es-tgCJW-Cu.js';

const SCROLL_DEBOUNCE_WAIT_MSEC_DEFAULT = 10;
const AUTO_SNAP_SCROLL_END_DEBOUNCE_WAIT_MESC_DEFAULT = 500;

var css_248z = ".SGCM_UIKIT_REACT_HorizontalScroller_containerRoot_1ois5_1 {\n  display: grid;\n  align-items: stretch;\n  grid-template-columns: auto 1fr auto;\n}\n.SGCM_UIKIT_REACT_HorizontalScroller_containerRoot_1ois5_1.SGCM_UIKIT_REACT_HorizontalScroller_isSideBlurred_1ois5_6 {\n  grid-template-columns: minmax(43px, min-content) 1fr minmax(43px, min-content);\n}\n\n.SGCM_UIKIT_REACT_HorizontalScroller_containerSideBlur_1ois5_10 {\n  z-index: 11;\n  display: flex;\n  align-items: center;\n  grid-row: 1/2;\n}\n.SGCM_UIKIT_REACT_HorizontalScroller_containerSideBlur_1ois5_10.SGCM_UIKIT_REACT_HorizontalScroller_isLeft_1ois5_16 {\n  justify-content: flex-start;\n  grid-column: 1/2;\n}\n.SGCM_UIKIT_REACT_HorizontalScroller_containerSideBlur_1ois5_10.SGCM_UIKIT_REACT_HorizontalScroller_isLeft_1ois5_16.SGCM_UIKIT_REACT_HorizontalScroller_isBlurred_1ois5_20 {\n  background-image: var(--sgcm-uikit-react-horizontal-scroller-left-arrow-gradient, linear-gradient(90deg, var(--side-blur-gradient-color, white) 0%, color-mix(in srgb, var(--side-blur-gradient-color, white) 87%, transparent) 49%, color-mix(in srgb, var(--side-blur-gradient-color, white) 0%, transparent) 100%));\n}\n.SGCM_UIKIT_REACT_HorizontalScroller_containerSideBlur_1ois5_10.SGCM_UIKIT_REACT_HorizontalScroller_isRight_1ois5_23 {\n  justify-content: flex-end;\n  grid-column: 3/4;\n}\n.SGCM_UIKIT_REACT_HorizontalScroller_containerSideBlur_1ois5_10.SGCM_UIKIT_REACT_HorizontalScroller_isRight_1ois5_23.SGCM_UIKIT_REACT_HorizontalScroller_isBlurred_1ois5_20 {\n  background-image: var(--sgcm-uikit-react-horizontal-scroller-right-arrow-gradient, linear-gradient(270deg, var(--side-blur-gradient-color, white) 0%, color-mix(in srgb, var(--side-blur-gradient-color, white) 87%, transparent) 49%, color-mix(in srgb, var(--side-blur-gradient-color, white) 0%, transparent) 100%));\n}\n\n.SGCM_UIKIT_REACT_HorizontalScroller_buttonArrow_1ois5_31 {\n  display: flex;\n  width: fit-content;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.SGCM_UIKIT_REACT_HorizontalScroller_iconArrow_1ois5_40 {\n  color: #6c6c6c;\n}\n\n.SGCM_UIKIT_REACT_HorizontalScroller_containerScrollContent_1ois5_44 {\n  z-index: 1;\n  overflow: auto;\n  grid-column: 1/4;\n  grid-row: 1/2;\n}\n@supports (scrollbar-width: none) {\n  .SGCM_UIKIT_REACT_HorizontalScroller_containerScrollContent_1ois5_44 {\n    scrollbar-width: none;\n  }\n}\n.SGCM_UIKIT_REACT_HorizontalScroller_containerScrollContent_1ois5_44::-webkit-scrollbar {\n  display: none;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */";
var styles = {"containerRoot":"SGCM_UIKIT_REACT_HorizontalScroller_containerRoot_1ois5_1","isSideBlurred":"SGCM_UIKIT_REACT_HorizontalScroller_isSideBlurred_1ois5_6","containerSideBlur":"SGCM_UIKIT_REACT_HorizontalScroller_containerSideBlur_1ois5_10","isLeft":"SGCM_UIKIT_REACT_HorizontalScroller_isLeft_1ois5_16","isBlurred":"SGCM_UIKIT_REACT_HorizontalScroller_isBlurred_1ois5_20","isRight":"SGCM_UIKIT_REACT_HorizontalScroller_isRight_1ois5_23","buttonArrow":"SGCM_UIKIT_REACT_HorizontalScroller_buttonArrow_1ois5_31","iconArrow":"SGCM_UIKIT_REACT_HorizontalScroller_iconArrow_1ois5_40","containerScrollContent":"SGCM_UIKIT_REACT_HorizontalScroller_containerScrollContent_1ois5_44"};
styleInject(css_248z);

const isScrollXEnd = ({ clientWidth, scrollLeft, scrollWidth, }, { tolerance = 0, } = {}) => (scrollWidth - clientWidth) <= Math.ceil(scrollLeft) + tolerance;
const getClosestItemScrollDistance = ({ scrollItemElementList, defaultScrollDistance, clientWidth, isBack, pageLeft, scrollLeft, }) => {
    const contentContainerLeft = Math.ceil(pageLeft);
    if (isBack) {
        const partiallyVisibleItem = scrollItemElementList.find((el) => {
            if (!el) {
                return false;
            }
            const { offsetLeft: itemElOffsetLeft, clientWidth: itemElClientWidth, } = el;
            const itemContentContainerLeft = (itemElOffsetLeft - contentContainerLeft);
            return (itemContentContainerLeft < scrollLeft
                && itemContentContainerLeft + itemElClientWidth >= scrollLeft);
        });
        if (!partiallyVisibleItem) {
            return defaultScrollDistance ?? clientWidth;
        }
        const { offsetLeft: scrollItemOffsetLeft, clientWidth: scrollItemClientWidth, } = partiallyVisibleItem;
        return (scrollLeft
            - (scrollItemOffsetLeft - contentContainerLeft)
            + (clientWidth - scrollItemClientWidth));
    }
    const partiallyVisibleItem = scrollItemElementList.findLast((el) => {
        if (!el) {
            return false;
        }
        const { offsetLeft: itemElOffsetLeft, clientWidth: itemElClientWidth, } = el;
        const itemContentContainerLeft = (itemElOffsetLeft - contentContainerLeft);
        const scrollContentEndScrollLeft = scrollLeft + clientWidth;
        return (itemContentContainerLeft < scrollContentEndScrollLeft
            && (itemContentContainerLeft + itemElClientWidth
                >= scrollContentEndScrollLeft));
    });
    if (!partiallyVisibleItem) {
        return defaultScrollDistance ?? clientWidth;
    }
    return (partiallyVisibleItem.offsetLeft - contentContainerLeft - scrollLeft);
};

const HorizontalScroller = ({ arrowLeft, arrowLeftContainerClassName, arrowRight, arrowRightContainerClassName, autoSnapScrollEnd, autoSnapScrollEndDebounceWaitMesc = (AUTO_SNAP_SCROLL_END_DEBOUNCE_WAIT_MESC_DEFAULT), children, className, contentContainerClassName, containerSideBlurClassName, contentContainerElRef: outerContentContainerElRef, isSideBlurred = false, scrollDebounceWaitMsec = SCROLL_DEBOUNCE_WAIT_MSEC_DEFAULT, scrollDistance, scrollEndTolerance, containerRef, }) => {
    const contentContainerElRef = useRef(null);
    const isScrollingRef = useRef(false);
    const autoSnapScrollLeftBeginRef = useRef(null);
    const [isArrwoLeftVisible, setIsArrowLeftVisible,] = useState(null);
    const [isArrwoRightVisible, setIsArrowRightVisible,] = useState(null);
    const getContentScrollDistance = ({ isBack, }) => {
        if (typeof scrollDistance === 'number') {
            return scrollDistance;
        }
        const { current: contentContainerEl } = contentContainerElRef;
        if (typeof scrollDistance !== 'function' || !contentContainerEl) {
            return 0;
        }
        const { clientWidth, scrollLeft, scrollWidth, } = contentContainerEl;
        return scrollDistance({
            clientWidth,
            isBack,
            pageLeft: contentContainerEl.getBoundingClientRect().left,
            scrollLeft,
            scrollWidth,
        });
    };
    const scrollContentContainer = (distance) => {
        const { current: isScrolling } = isScrollingRef;
        const { current: contentContainerEl } = contentContainerElRef;
        if (isScrolling || !contentContainerEl) {
            return;
        }
        isScrollingRef.current = true;
        contentContainerEl.scrollTo({
            top: 0,
            left: contentContainerEl.scrollLeft + distance,
            behavior: 'smooth',
        });
    };
    const onContentAutoSnapScrollEnd = useMemo(() => debounce(() => {
        const { current: contentContainerEl } = contentContainerElRef;
        const { current: autoSnapScrollLeftBegin } = autoSnapScrollLeftBeginRef;
        if (!contentContainerEl || autoSnapScrollLeftBegin === null) {
            return;
        }
        const { scrollLeft, scrollWidth, clientWidth, } = contentContainerEl;
        autoSnapScrollLeftBeginRef.current = null;
        if (scrollLeft <= autoSnapScrollLeftBegin) {
            return;
        }
        const isContentContainerNextScrollXEnd = isScrollXEnd({
            clientWidth,
            scrollLeft,
            scrollWidth,
        }, {
            tolerance: scrollEndTolerance,
        });
        if (!isContentContainerNextScrollXEnd) {
            return;
        }
        contentContainerEl.scrollTo({
            left: scrollWidth,
            behavior: 'smooth',
        });
    }, autoSnapScrollEndDebounceWaitMesc), [
        autoSnapScrollEndDebounceWaitMesc,
        scrollEndTolerance,
    ]);
    const onContentArrowRefresh = useMemo(() => debounce(() => {
        const { current: contentContainerEl } = contentContainerElRef;
        if (!contentContainerEl) {
            return;
        }
        const { requestAnimationFrame, cancelAnimationFrame } = window;
        const animationReqId = requestAnimationFrame(() => {
            const { scrollLeft, scrollWidth, clientWidth, } = contentContainerEl;
            setIsArrowLeftVisible(scrollLeft > 0);
            const isContentContainerScrollXEnd = isScrollXEnd({
                scrollLeft,
                scrollWidth,
                clientWidth,
            }, {
                tolerance: scrollEndTolerance,
            });
            setIsArrowRightVisible(!isContentContainerScrollXEnd);
            cancelAnimationFrame(animationReqId);
            if (autoSnapScrollLeftBeginRef.current === null) {
                autoSnapScrollLeftBeginRef.current = scrollLeft;
            }
            if (autoSnapScrollEnd) {
                onContentAutoSnapScrollEnd();
            }
            isScrollingRef.current = false;
        });
    }, scrollDebounceWaitMsec), [
        autoSnapScrollEnd,
        scrollDebounceWaitMsec,
        scrollEndTolerance,
        onContentAutoSnapScrollEnd,
    ]);
    useEffect(() => {
        onContentArrowRefresh();
    }, [onContentArrowRefresh]);
    useEffect(() => {
        const { current: contentContainerEl } = contentContainerElRef;
        if (!contentContainerEl) {
            return undefined;
        }
        const resizeObserver = new ResizeObserver(() => {
            onContentArrowRefresh();
        });
        resizeObserver.observe(contentContainerEl);
        return () => {
            resizeObserver.disconnect();
        };
    }, [onContentArrowRefresh]);
    return (jsxs("div", { ref: containerRef, className: cx(styles.containerRoot, {
            [styles.isSideBlurred]: isSideBlurred,
        }, className), children: [jsx("div", { ref: (el) => {
                    contentContainerElRef.current = el;
                    if (!outerContentContainerElRef) {
                        return;
                    }
                    const externalContentContainerElRef = outerContentContainerElRef;
                    externalContentContainerElRef.current = el;
                }, className: cx(styles.containerScrollContent, contentContainerClassName), onScroll: onContentArrowRefresh, children: children }), isArrwoLeftVisible && (jsx("div", { className: cx(styles.containerSideBlur, styles.isLeft, {
                    [styles.isBlurred]: isSideBlurred,
                }, containerSideBlurClassName), children: jsx("button", { "aria-label": "Scroll left", className: cx(styles.buttonArrow, arrowLeftContainerClassName), type: "button", onClick: () => {
                        scrollContentContainer(getContentScrollDistance({
                            isBack: true,
                        }) * -1);
                    }, children: arrowLeft }) })), isArrwoRightVisible && (jsx("div", { className: cx(styles.containerSideBlur, styles.isRight, {
                    [styles.isBlurred]: isSideBlurred,
                }, containerSideBlurClassName), children: jsx("button", { "aria-label": "Scroll right", className: cx(styles.buttonArrow, arrowRightContainerClassName), type: "button", onClick: () => {
                        scrollContentContainer(getContentScrollDistance({
                            isBack: false,
                        }));
                    }, children: arrowRight }) }))] }));
};

export { HorizontalScroller as H, getClosestItemScrollDistance as g, isScrollXEnd as i };
//# sourceMappingURL=component-Dmj9dZNF.js.map
